import { BadgeColor } from '@billy/design-system'

import { VatDeclarationStatus } from '../enums/vatDeclarationStatus'

export const vatDeclarationStatusToColorVariant: Record<VatDeclarationStatus, BadgeColor> = {
  [VatDeclarationStatus.Draft]: 'accent',
  [VatDeclarationStatus.OverduePayment]: 'danger',
  [VatDeclarationStatus.OverdueSubmission]: 'danger',
  [VatDeclarationStatus.Paid]: 'success',
  [VatDeclarationStatus.Pending]: 'accent',
  [VatDeclarationStatus.ReadyToPay]: 'warning',
  [VatDeclarationStatus.ReadyToSubmit]: 'warning',
  [VatDeclarationStatus.SubmissionFailed]: 'danger',
}
